import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import './app/icons/font-awesome.js';
import './app/icons/font-awesome-solid.js';

// Legacy links: the site used hash routing until 2026-09-17 (https://eszes.in/#/aboutus).
// Rewrite them to the path form before the router boots so old bookmarks and search
// results still land on the right page.
const legacyHash = window.location.hash;
if (legacyHash.startsWith('#/')) {
    window.history.replaceState(null, '', legacyHash.slice(1) + window.location.search);
}

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
